var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-btn',{on:{"click":_vm.handleGenerateDataSet}},[_vm._v(_vm._s(_vm.$t('dataset.generate')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }